import React from "react";
import { View, TextInput, Pressable, StyleSheet } from "react-native";
import GrayCross from "@assets/svg/GrayCross";
import { C, Search } from "../theme";

// The search box on the routing screens: the Select delivery boy sheet's
// look, full width under the header, with a clear button while there's text.
const RoutingSearch = ({ value, onChangeText, placeholder, testID }) => (
  <View style={styles.search}>
    <Search size={16} />
    <TextInput
      testID={testID}
      value={value}
      onChangeText={onChangeText}
      placeholder={placeholder}
      placeholderTextColor={C.disabledInk}
      style={styles.input}
      autoCorrect={false}
      autoCapitalize="none"
      returnKeyType="search"
    />
    {value ? (
      <Pressable
        testID={testID ? `${testID}-clear` : undefined}
        accessibilityRole="button"
        accessibilityLabel="Clear search"
        hitSlop={10}
        onPress={() => onChangeText("")}
      >
        <GrayCross width={18} height={18} />
      </Pressable>
    ) : null}
  </View>
);

export default RoutingSearch;

const styles = StyleSheet.create({
  search: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    borderWidth: 1,
    borderColor: C.border,
    borderRadius: 10,
    paddingHorizontal: 12,
    marginHorizontal: 16,
    marginTop: 12,
    backgroundColor: C.surface,
  },
  input: {
    flex: 1,
    paddingVertical: 9,
    fontSize: 14,
    color: C.ink,
  },
});
